export const OneShiftTimeSlots = [
    {start: "08:00", end: "09:00"},
    {start: "09:15", end: "10:15"},
    {start: "09:45", end: "10:45"},
    {start: "10:30", end: "11:30"},
    {start: "10:45", end: "11:45"},
    {start: "11:00", end: "12:00"},
    {start: "13:30", end: "14:30"},
    {start: "14:45", end: "15:45"},
    {start: "15:15", end: "16:15"},
    {start: "16:00", end: "17:00"},
    {start: "16:15", end: "17:15"},
    {start: "16:30", end: "17:30"},
    {start: "18:00", end: "19:00"},
    {start: "19:15", end: "20:15"},
    {start: "19:45", end: "20:45"},
    {start: "20:30", end: "21:30"},
    {start: "20:45", end: "21:45"},
    {start: "21:00", end: "22:00"},
];
export const TwoShiftTimeSlots = [
    {start: "08:00", end: "09:30"},
    {start: "09:15", end: "10:45"},
    {start: "09:45", end: "11:15"},
    {start: "10:30", end: "12:00"},
    {start: "13:30", end: "15:00"},
    {start: "14:45", end: "16:15"},
    {start: "15:15", end: "16:45"},
    {start: "16:00", end: "17:30"},
    {start: "18:00", end: "19:30"},
    {start: "19:15", end: "20:45"},
    {start: "19:45", end: "21:15"},
    {start: "20:30", end: "22:00"},
];
export const ThreeTimeSlots = [
    {start: "08:00", end: "10:30"},
    {start: "09:15", end: "11:45"},
    {start: "13:30", end: "16:00"},
    {start: "14:45", end: "17:15"},
    {start: "18:00", end: "20:30"},
    {start: "19:15", end: "21:45"},
];
export const TutorType = {
    SpecialTutor: 1,       // Gia sư đặc biệt
    PostOpeningTutor: 2,   // Gia sư sau khai giảng
    BufferClassTutor: 3,   // Gia sư lớp đệm
    PolicyTutor: 4,        // Gia sư chính sách
    MilitaryTutor: 5,       // Gia sư quân sự
    RetestTutor: 6,        // Gia sư retest
}
export const TaskStatusOfTutor = {
    doing: 0,
    done: 1,
    cancel: 2,
}
export const PolicyTutorContent = {
    WRITING_REVIEW: 1,
    IELTS_SPEAKING_PRACTICE: 2,
    VOCABULARY_PRONUNCIATION: 3,
    LISTENING_METHOD: 4,
    PRONUNCIATION_METHOD: 5,
    GRAMMAR_METHOD: 6,
    VOCABULARY_METHOD: 7,
    LISTENING_EXAM_PRACTICE: 8,
    READING_EXAM_PRACTICE: 9,
    WRITING_EXAM_PRACTICE: 10,
    SPEAKING_EXAM_PRACTICE: 11,
    OTHER_SUPPORT: 12
}
export const NeedEvaluationStatus = 6;
export const Attendance = 1